import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/WorflowCard.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTags, faDownload, faHeart } from "@fortawesome/free-solid-svg-icons";

const formatNumber = (num) => {
  if (num >= 1e9) return (num / 1e9).toFixed(2) + "B";
  if (num >= 1e6) return (num / 1e6).toFixed(2) + "M";
  if (num >= 1e3) return (num / 1e3).toFixed(2) + "K";
  return num.toString();
};

const formatDate = (uploadDate) => {
  const now = new Date();
  const upload = new Date(uploadDate);
  const diffMs = now - upload;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 51) return `${diffMins} minutes ago`;
  if (diffMins < 60) return `about 1 hour ago`;
  if (diffHours < 24) return `${diffHours} hours ago`;
  if (diffDays < 29) return `${diffDays} days ago`;
  if (diffDays < 36) return `about a month ago`;
  return `${upload.toLocaleString("default", {
    month: "long",
  })} ${upload.getDate()}, ${upload.getFullYear()}`;
};

const WorkflowCard = ({ workflow }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/workflow/${workflow.id}`, { state: { workflow } });
  };

  const handleUserClick = (e) => {
    e.stopPropagation(); // Prevent event bubbling to parent
    navigate(`/u/${workflow.user_id}`, { state: { workflow } });
  };

  return (
    <div className={styles.workflowCard} onClick={handleCardClick}>
      <h3 className={styles.workflowTitle}>{workflow.name}</h3>
      <h4 className={styles.workflowUser} onClick={handleUserClick}>by {workflow.user}</h4>
      {workflow.description && (
        <p className={styles.workflowSubtitle}>
          {" "}
          {
            <div className={styles.workflowDetail}>
              <FontAwesomeIcon
                icon={faTags}
                className={styles.workflowCardIcon}
              />{" "}
              {workflow.tags.replace("{", "").replace("}", "")}
            </div>
          }
        </p>
      )}
      <div className={styles.workflowDetails}>
        <div className={`${styles.workflowDetail} ${styles.ellipsis}`}>
          Uploaded {formatDate(workflow.upload_date)}
        </div>
        <div className={styles.workflowDetail}>
          •{" "}
          <FontAwesomeIcon
            icon={faDownload}
            className={styles.workflowCardIcon}
          />{" "}
          {formatNumber(workflow.downloads || 0)} •
        </div>
        <div className={styles.workflowDetail}>
          <FontAwesomeIcon icon={faHeart} className={styles.workflowCardIcon} />{" "}
          {formatNumber(workflow.likes || 0)}
        </div>
      </div>
    </div>
  );
};

export default WorkflowCard;
